import { useParams, useNavigate } from "react-router-dom";
import ManageGLAccountMastForm from "components/ui/ManageGLAccountMastForm";

export default function EditAccountMaster() {
  const { ps_Id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = (data) => {
    // Navigate back to the list page after successful update
    navigate("/gl-accounts-master");
  };

  const handleCancel = () => {
    // Navigate back to the list page
    navigate("/gl-accounts-master");
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="mb-6">
        <div className="sm:flex-auto">
          <h1 className="font-semibold leading-6 text-3xl text-gray-900">
            Edit Account Master
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Update the details of the selected account master.
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
        <div className="px-4 py-6 sm:p-8">
          <ManageGLAccountMastForm
            ps_Id={ps_Id}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
} 